var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"so-promocodes"},_vm._l((_vm.data.rows),function(document){return _c('so-promocode',{key:document.id,staticClass:"so-promocodes__item",attrs:{"data":document}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }